import PositionPref from "../../enums/position-pref";
import FootballState from "../../state/football-state";
import Pref from "./position-pref";

export default class PatFumbleForcedByPositionPref extends Pref {
    constructor(play, fragment) {
        super(play, fragment);
    }

    resolve() {
        if (this.play.historyContains(FootballState.Run)) {
            return PositionPref.RUSH_TACKLE;
        }
        return [];
    }
}
